$(document).ready(function($) {
    $(".close-menu").click(function(){
      $("#shopify-section-side-menu").css({
        left: 0
      }).animate({
        left: -1000
      }, "slow");
    });
    $(".open-menu").click(function(){
      $("#shopify-section-side-menu").css({
          left: -1000
        }).animate({
          left: 0
        }, "slow");
    });
  
});

$(document).ready(function(){
    $('.drop-down').click(function(e){
        e.preventDefault();
        $(this).next('ul').slideToggle();
    })
});
/*
$(document).ready(function($) {
    $(".list-nav:nth-child(2)").click(function(){
      $(".sub-nav").toggle();
      var element = document.querySelector('.sub-nav');
      element.classList.toggle('my-class');
    });
});*/

$(document).ready(function(){
  $('.tab-link').click( function() {
	
	var tabID = $(this).attr('data-tab');
	
	$(this).addClass('active').siblings().removeClass('active');
	
	$('#tab-'+tabID).addClass('active').siblings().removeClass('active');
  });

  ///step form start///
    
  ///step form end///
  

  var acc = document.getElementsByClassName("sc-dlVxhl");
  var i;
  
  for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function() {
      /* Toggle between adding and removing the "active" class,
      to highlight the button that controls the panel */
      this.classList.toggle("active");
  
      /* Toggle between hiding and showing the active panel */
      var ezPFYY = this.nextElementSibling;
      if (ezPFYY.style.display === "block") {
        ezPFYY.style.display = "none";
      } else {
        ezPFYY.style.display = "block";
      }
    });
  }

  $('.product_slider').slick({
    centerMode: true,
    centerPadding: '60px',
    infinite: true,
    arrows: true,
    dots: true,
    autoplay:true,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          arrows: true,
          centerMode: true,
          centerPadding: '40px',
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          arrows: true,
          centerMode: true,
          centerPadding: '40px',
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          arrows: false,
          centerMode: true,
          centerPadding: '40px',
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
})

$(document).on("scroll", function(){
  if ($(document).scrollTop() > 80){
    $(".custom_head").addClass("shrink");
  } else {
    $(".custom_head").removeClass("shrink");
  }
});
